<div class="row">
	<div class="col">

		<div class="page-header">

			<div class="float-end pt-4" style="width:300px; max-width:50vw;">
				<div class="input-group">
					<input type="text" class="form-control" id="status-search" placeholder="Keresés..." oninput="Anvil.page.quickSearchTerminal($(this).val())" />
					<span class="input-group-text"><i class="fa fa-search"></i></span>
				</div>
			</div>

			<h2>Terminálok</h2>
			<% if (company === null) { %>
			<span id="company-name">Nincs megnyitva cég</span>
			<% } else { %>
			<span id="company-name"><%= company.name %></span>
			<% } %>
		</div>

		<div class="grid-wrapper" style="margin:0; overflow-y:auto;">

			<% if (company === null) { %>
			<div class="text-secondary text-center pt-3"><small>-- Válaszon ki egy céget --</small></div>
			<% } else { %>
			<ul class="list-group list-group-flush">
				<% for (const site of company.sites) { %>
				<li class="list-group-item p-0">
					<table class="table table-sm grid-table w-100">
						<thead>
							<tr>
								<th><%= site.name %></th>
							</tr>
						</thead>
					</table>
					<div class="row g-1 p-1">
						<% for (const terminal of site.terminals) { %>
						<div class="col-auto">
							<div class="row g-0 align-items-stretch">
								<div class="col-auto" style="width:240px;">
									<div class="card bg-body-secondary">
										<div class="card-header pe-1">
											<div class="row g-0">
												<div class="col-auto">
													<i class="fa fa-2x fa-fw fa-desktop me-3 text-secondary" style="margin-top:6px;"></i>
												</div>
												<div class="col">
													<strong><%= terminal.device_info.hostname || terminal.name %></strong><br />
													<small><%= terminal.version || 'ismeretlen verzió' %></small>
												</div>
												<% if (terminal.notes) { %>
												<div class="col-auto">
													<button class="btn btn-link" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="bottom" title="<div class='text-start'><strong>Megjegyzések</strong><hr class='my-1' /><div style='font-size:0.7em;' class='mb-0'><%= terminal.notes.replaceAll('\n', '<br />') %></div></div>"><i class="fa fa-lg fa-info-circle"></i></button>
												</div>
												<% } %>
											</div>
										</div>
										<table class="m-2 mb-0" style="font-size:0.8em;">
											<tr>
												<td valign="top" style="width:75px;">Első indítás</td>
												<td class="text-info"><%= Anvil.moment(terminal.first_start).format('YYYY.MM.DD HH:mm:ss') %></td>
											</tr>
											<tr>
												<td valign="top">Utolsó indítás</td>
												<td class="text-info"><%= Anvil.moment(terminal.recent_start).format('YYYY.MM.DD HH:mm:ss') %></td>
											</tr>
											<tr>
												<td valign="top">Indítások</td>
												<td class="text-info"><%= terminal.startups %></td>
											</tr>
											<tr>
												<td valign="top">Társított AP</td>
												<td class="text-info"><strong><%= terminal.default_cashreg_ap %></strong></td>
											</tr>
										</table>
										<% if (terminal.type == 'windows') { %>
										<hr class="mx-4 my-2" style="background-color:rgba(0, 0, 0, 0.4);" />
										<table class="mx-2 my-0" style="font-size:0.8em;">
											<tr>
												<td valign="top" style="width:17px;"><i class="fa fa-fw fa-microchip"></i></td>
												<td class="text-info"><%- terminal.device_info.cpu[0].model.split('@')[0] %></td>
											</tr>
											<tr>
												<td valign="top"><i class="fa fa-fw fa-memory"></i></td>
												<td class="text-info"><%= Anvil.numeral(terminal.device_info.memory.total).format('0.00 b') %> RAM</td>
											</tr>
											<%
											const ethernet_key = Object.keys(terminal.device_info.network).find(n => n.startsWith('Ethernet'))
											if (ethernet_key !== undefined) {
												const ipv4 = terminal.device_info.network[ethernet_key].find(x => x.family == 'IPv4')
											%>
											<tr>
												<td valign="top"><i class="fa fa-fw fa-ethernet"></i></td>
												<td class="text-info">
													<% if (ipv4) { %><%= ipv4.address %><% } %>
												</td>
											</tr>
											<% } else { %>
											<tr>
												<td valign="top" class="text-warning"><i class="fa fa-fw fa-ethernet"></i></td>
												<td class="text-warning">
													nincs ethernet
												</td>
											</tr>
											<% } %>
											<%
											const wifi_key = Object.keys(terminal.device_info.network).find(n => n.startsWith('Wi-Fi'))
											if (wifi_key !== undefined) {
												const ipv4 = terminal.device_info.network[wifi_key].find(x => x.family == 'IPv4')
											%>
											<tr>
												<td valign="top"><i class="fa fa-fw fa-wifi"></i></td>
												<td class="text-info">
													<% if (ipv4) { %><%= ipv4.address %><% } %>
												</td>
											</tr>
											<% } else { %>
											<tr>
												<td valign="top"><i class="fa fa-fw fa-wifi"></i></td>
												<td class="text-info">
													nincs wifi
												</td>
											</tr>
											<% } %>
											<tr>
												<td valign="top"><i class="fa fa-fw fa-hdd"></i></td>
												<td class="text-info">
												<% if (terminal.device_info.drive) { %>
													<%= Anvil.numeral(terminal.device_info.drive.free).format('0.00 b') %> szabad
												<% } else { %>
													ismeretlen
												<% } %>
												</td>
											</tr>
											<tr>
												<td valign="top"><i class="fab fa-fw fa-windows"></i></td>
												<td class="text-info"><%= terminal.device_info.os.version %> (<%= terminal.device_info.os.arch %>)<br /><%= terminal.device_info.os.release %></td>
											</tr>
										</table>
										<% } %>
										<hr class="mx-4 my-2" style="background-color:rgba(0, 0, 0, 0.4);" />
										<div class="text-center mb-2">
											<strong style="color:goldenrod;"><%= Anvil.numeral(terminal.licence_fee).format('0,0') %> Ft/hó</strong>
										</div>
										<div class="card-footer p-0 overflow-hidden">
											<div class="btn-group w-100">
												<button class="btn btn-dark <% if (terminal.anydesk_id) { %>text-warning<% } else { %>disabled text-secondary<% } %>" style="flex-grow:1; border-radius:0; font-size:0.7em;" onclick="Anvil.page.connect_with_anydesk('<%- terminal.machine_id %>')"><i class="fa fa-2x fa-headset mb-1"></i><br />Anydesk</button>
												<button class="btn btn-dark text-primary" style="flex-grow:2; border-radius:0; font-size:0.7em;" onclick="Anvil.page.open('<%- terminal.machine_id %>')"><i class="fa fa-2x fa-cogs mb-1"></i><br />Beállítások</button>
											</div>
										</div>
									</div>
								</div>
								<% if (terminal.ecr_info) { %>
									<% if (terminal.version != 'c-Store' && terminal.version != 'haccp' && Anvil.versions.compare(terminal.version, '2.2.12', '>=')) { %>
									<div class="col-auto ms-1" style="width:200px;">
										<div class="card bg-dark h-100">
											<div class="position-absolute top-50 translate-middle bg-body-secondary text-secondary rounded-circle" style="padding-top:1px; width:29px; height:29px; text-align:center; left:-2px; border:4px solid var(--bs-body-bg);">
												<i class="fa fa-link"></i>
											</div>
											<div class="card-header">
												<div class="row g-0">
													<div class="col-auto">
														<i class="fa fa-2x fa-fw fa-cash-register me-3 text-secondary" style="margin-top:6px;"></i>
													</div>
													<div class="col">
														<% if (terminal.ecr_info.type == 'ms-freepos') { %>
														<strong>MS FreePOS</strong><br />
														<small><%= terminal.ecr_info.http_host %>:<%= terminal.ecr_info.http_port %></small>
														<% } else { %>
														<strong>Sam4s</strong><br />
														<small>COM<%= terminal.ecr_info.com_port %> at <%= terminal.ecr_info.baud_rate %> Bd</small>
														<% } %>
													</div>
												</div>
											</div>
										</div>
									</div>
									<% } else { %>
										<% if (terminal.ecr_info.aee) for (const aee of terminal.ecr_info.aee) { %>
										<div class="col-auto ms-1" style="width:200px;">
											<div class="card bg-dark h-100">
												<div class="position-absolute top-50 translate-middle bg-body-secondary text-secondary rounded-circle" style="padding-top:1px; width:29px; height:29px; text-align:center; left:-2px; border:4px solid var(--bs-body-bg);">
													<i class="fa fa-link"></i>
												</div>
												<div class="card-header">
													<div class="row g-0">
														<div class="col-auto">
															<i class="fa fa-2x fa-fw fa-cash-register me-3 text-secondary" style="margin-top:6px;"></i>
														</div>
														<div class="col">
															<strong>MS FreePOS</strong><br />
															<small><%= aee.http_host %>:<%= aee.http_port %></small>
														</div>
													</div>
												</div>
											</div>
										</div>
										<% } %>
										<% if (terminal.ecr_info.sam4s) for (const sam4s of terminal.ecr_info.sam4s) { %>
										<div class="col-auto ms-1" style="width:200px;">
											<div class="card bg-dark h-100">
												<div class="position-absolute top-50 translate-middle bg-body-secondary text-secondary rounded-circle" style="padding-top:1px; width:29px; height:29px; text-align:center; left:-2px; border:4px solid var(--bs-body-bg);">
													<i class="fa fa-link"></i>
												</div>
												<div class="card-header">
													<div class="row g-0">
														<div class="col-auto">
															<i class="fa fa-2x fa-fw fa-cash-register me-3 text-secondary" style="margin-top:6px;"></i>
														</div>
														<div class="col">
															<strong>Sam4s</strong><br />
															<small>COM<%= sam4s.com_port %> at <%= sam4s.baud_rate %> Bd</small>
														</div>
													</div>
												</div>
											</div>
										</div>
										<% }  %>
									<% } %>
								<% } %>
							</div>
						</div>
						<% } %>
					</div>
				</li>
			<% } %>
			</ul>
			<% } %>
		</div>

	</div>
</div>

<div class="py-3">

</div>
